module.exports = __webpack_public_path__ + "static/media/3.61d43a32.svg";